// Configuration routes are handled by mesf-core through customConfigurations
// Do NOT add routes here that are already in configurations.tsx
// The MESFProvider automatically handles /configuration/* routes

export const configurationRoutes: { path: string; element: JSX.Element }[] = [];
